import colors from "shared/theme/colors";

export const lightTheme = {
  themeName: "light",

  /// ///////////////////////////////////////
  // Use SPOR components and it's color variables if possible
  // If component is custom or overwritten, use the following color variables
  // Don't create color variables inside your custom components;
  // Create them here, supported by appPalette.ts
  // Don't even think about using a color without a variable
  /// ///////////////////////////////////////

  // BACKGROUND
  colorBackgroundBase: colors.mint,
  colorBackgroundMain: colors.white,
  colorBackgroundSecondary: colors.lightGrey,
  colorBackgroundTertiary: colors.white,

  // TEXT
  colorTextMain: colors.teal800,
  colorTextSecondary: colors.darkGrey,
  colorTextTertiary: colors.dimGrey,
  colorTextDisabled: colors.blackAlpha["400"],
  colorTextInverted: colors.white,
  colorSporTextInverted: colors.white,

  // OUTLINES
  colorOutlineMain: colors.blackAlpha["300"],
  colorOutlineSecondary: colors.blackAlpha["100"],
  colorOutlineFocus: colors.greenHaze,
  colorOutlineInverted: "#00000066", // Aka rgba(0, 0, 0, 0.4). Keep as hex as it is used in calculation

  // Icons
  colorIconMain: colors.teal800,
  colorIconSecondary: colors.darkGrey,
  colorIconTertiary: colors.dimGrey,
  colorIconDisabled: colors.blackAlpha["400"],
  colorIconInverted: colors.white,
  colorSporIconInverted: colors.white,

  // SEMANTICS
  // Alarm 1
  colorAlarm: colors.raspberry,
  colorAlarmPulse: colors.wine,
  colorAlarmFill: colors.pink,
  colorAlarmFillPulse: colors.lightRed,
  colorAlarmOutline: colors.salmon,
  colorAlarmTextMain: colors.maroon,
  colorAlarmTextSecondary: colors.burgundy,
  colorAlarmTextTertiary: colors.pink,

  // Alarm 2
  colorSecondaryAlarm: colors.autumn,
  colorSecondaryAlarmPulse: colors.russet,
  colorSecondaryAlarmFill: colors.bisque,
  colorSecondaryAlarmFillPulse: colors.champagne,
  colorSecondaryAlarmOutline: colors.rajah,
  colorSecondaryAlarmTextMain: colors.chocolate,
  colorSecondaryAlarmTextSecondary: colors.wood,
  colorSecondaryAlarmTextTertiary: colors.bisque,

  // Warning
  colorWarning: colors.mustard,
  colorWarningPulse: colors.bronze,
  colorWarningFill: colors.cornsilk,
  colorWarningFillPulse: colors.blonde,
  colorWarningOutline: colors.banana,
  colorWarningTextMain: colors.coffee,
  colorWarningTextSecondary: colors.cigar,
  colorWarningTextTertiary: colors.cornsilk,

  // Success
  colorSuccess: colors.primaryGreen,
  colorSuccessPulse: colors.pine,
  colorSuccessFill: colors.mint,
  colorSuccessFillPulse: colors.seaMist,
  colorSuccessOutline: colors.coralGreen,
  colorSuccessTextMain: colors.jungle,
  colorSuccessTextSecondary: colors.darkTeal,
  colorSuccessTextTertiary: colors.mint,

  // Info
  colorInfo: colors.blueberry,
  colorInfoPulse: colors.darkBlue,
  colorInfoFill: colors.icyBlue,
  colorInfoFillPulse: colors.lightBlue,
  colorInfoOutline: colors.sky,
  colorInfoTextMain: colors.navy,
  colorInfoTextSecondary: colors.darkBlue,
  colorInfoTextTertiary: colors.icyBlue,

  // Neutral
  colorNeutral: colors.dimGrey,
  colorNeutralPulse: colors.iron,
  colorNeutralFill: colors.white,
  colorNeutralFillPulse: colors.lightGrey,
  colorNeutralOutline: colors.silver,
  colorNeutralTextMain: colors.darkGrey,
  colorNeutralTextSecondary: colors.carbon,
  colorNeutralTextTertiary: colors.lightGrey,

  // System
  colorSystem: colors.violet600,
  colorSystemPulse: colors.violet700,
  colorSystemFill: colors.violet50,
  colorSystemFillPulse: colors.violet100,
  colorSystemOutline: colors.violet200,
  colorSystemTextMain: colors.violet900,
  colorSystemTextSecondary: colors.violet800,
  colorSystemTextTertiary: colors.violet50,

  // Transparent
  colorTransparentFill: "transparent",
  colorTransparentOutline: colors.blackAlpha["100"],
  colorTransparentTextMain: colors.jungle,

  // Transparent Inverted
  colorTransparentInvertedFill: "transparent",
  colorTransparentInvertedOutline: colors.blackAlpha["400"],
  colorTransparentInvertedTextMain: colors.white,
  colorTransparentInvertedTextTertiary: colors.jungle,

  // Ghost
  colorGhostFill: "transparent",
  colorGhostOutline: colors.blackAlpha["100"],
  colorGhostTextMain: colors.jungle,

  // Alerts counter (badge)
  colorAlertsCounterWarningBackground: colors.burntYellow,
  colorAlertsCounterSuccessBackground: colors.primaryGreen,
  colorAlertsCounterTextOnColor: colors.white,
  colorAlertsCounterWarningText: colors.black,

  // Interaction states
  colorSelected: colors.seaMist,
  filterHover: "brightness(0.8) contrast(1.1)",
  filterSelected: "brightness(0.9) contrast(1.1)",

  // Surface colors
  surfaceSelected: colors.blackAlpha["50"],
  surfaceHover: colors.blackAlpha["100"],
  surfaceDefault: colors.white,
  surfaceDisabled: colors.blackAlpha["100"],

  // EXTRA
  skeletonElementColor: colors.platinum,
  boxShadow: "0px 2px 18px 1px #0126221a",
  dropShadow: "drop-shadow(0px 2px 18px #0126221a)", // Used for filter , can't use boxShadow as it is not supported in filter
  overlayColor: "#000000b3", // Aka rgba(0, 0, 0, 0.7). Keep as hex as it is used in calculation
  trainMapStretchBuilder: colors.seaMist,
  trainSVGStrokeColor: colors.teal1000,
};

export type LightTheme = typeof lightTheme;
